import { emitter, Experiment, Variant } from '@marvelapp/react-ab-test';
import { Fragment, useRef } from 'react';

import Preferences from '~features/admin/Preferences';
import useGetCompanyInfo from '~hooks/query/company/useCompanyInfo';
import useGetCompanyStates from '~hooks/query/company/useCompanyStates';
import useMedia from '~hooks/useMedia';
import { useRouterQuery } from '~hooks/useRouterQuery';
import { setAmplitudeUserProperties } from '~utils/common/thirdPartyEvent';

import Aside from '../Aside';
import EmployeeInfo from '../EmployeeInfo';
import ErrorPage from '../ErrorPage';
import Header from '../Header';
import useCardObserver from '../hooks/useCardObserver';
import InterviewReviewInfo from '../InterviewReviewInfo';
import JobdomInfo from '../JobdomInfo';
import ManageCompanyInfo from '../ManageCompanyInfo';
import ReviewInfo from '../ReviewInfo';
import SalaryInfo from '../SalaryInfo';
import SalesInfo from '../SalesInfo';
import SummaryInfo from '../SummaryInfo';
import WantedJobPostingInfo from '../WantedJobPostingInfo';
import * as S from './style';

emitter.addPlayListener((experimentName, variantName) => {
  setAmplitudeUserProperties({
    abTest_company_community: variantName,
  });
});

export default function CompanyPage() {
  const { isMobile } = useMedia();
  const companyId = useRouterQuery('companyId');
  const { data: companyStates, status: companyStatesStatus } = useGetCompanyStates(companyId);
  const { data: companyInfo, status: companyInfoStatus } = useGetCompanyInfo(companyId);
  const { registerRef, selectedMenu } = useCardObserver();
  const endOfWrapperRef = useRef<HTMLDivElement>(null);

  if (companyInfoStatus === 'error' || companyStatesStatus === 'error') {
    return <ErrorPage />;
  }

  if (!companyStates) {
    return null;
  }

  return (
    <S.Wrapper>
      <Preferences />
      <Header selectedMenu={selectedMenu} />
      <S.ContentWrapper>
        <SummaryInfo registerRef={registerRef} companyStates={companyStates} />
        <Aside targetRef={endOfWrapperRef} companyInfo={companyInfo} />
        <ReviewInfo registerRef={registerRef} />
        <InterviewReviewInfo registerRef={registerRef} />
        <WantedJobPostingInfo companyId={companyId} isRecommended={false} />
        <EmployeeInfo registerRef={registerRef} companyStates={companyStates} />
        <SalaryInfo registerRef={registerRef} companyStates={companyStates} />
        <SalesInfo registerRef={registerRef} companyStates={companyStates} />
        <Experiment name='abTest_company_community'>
          <Variant name='A'>
            <JobdomInfo registerRef={registerRef} />
          </Variant>
          <Variant name='B'>
            <div />
          </Variant>
        </Experiment>

        <WantedJobPostingInfo companyId={companyId} isRecommended={true} />

        <a
          data-attribute-id='company__banner__click'
          data-banner-location='bottom'
          data-banner-type='ads'>
          {isMobile ? (
            <S.GoogleAdsBanner bannerType='mobileBanner' slotId='8076432031' />
          ) : (
            <S.GoogleAdsBanner bannerType='leaderBoard' slotId='8397610632' />
          )}
        </a>
        <ManageCompanyInfo />
      </S.ContentWrapper>
      <div ref={endOfWrapperRef} />
    </S.Wrapper>
  );
}
